import React, { useEffect } from "react";

type Props = {
  kind: "signup" | "login";
};

export const BUILDER_OAUTH_HANDOVER_KEY = "builderOAuthHandover";

export const OAuthHandover: React.FC<Props> = ({ kind }) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const pickFirst = (...keys: string[]): string => {
      for (const k of keys) {
        const v = params.get(k);
        if (v) return v;
      }
      return "";
    };

    const detail =
      kind === "signup"
        ? {
            type: "oauth-social-signup",
            email: pickFirst("email", "userEmail", "emailAddress", "mail"),
            firstName: pickFirst("firstName", "first_name", "givenName", "given_name"),
            lastName: pickFirst("lastName", "last_name", "familyName", "family_name", "surname"),
            providerUserId: pickFirst("providerUserId", "provider_user_id", "providerId", "sub", "id"),
            providerType: pickFirst("providerType", "provider", "provider_type") || "google",
            source: params.get("source") || "",
          }
        : {
            type: "oauth-social-login",
            email: pickFirst("email", "userEmail", "emailAddress", "mail"),
            apiKeyEncrypted: params.get("apiKey") || params.get("api_key") || params.get("token") || "",
            source: params.get("source") || "",
          };

    const postViaBroadcast = (msg: object) => {
      try {
        if (typeof BroadcastChannel === "undefined") return false;

        const bc = new BroadcastChannel("oppizi-oauth-handover");

        bc.postMessage(msg);

        setTimeout(() => {
          bc.close();
        }, 0);

        return true;
      } catch (err) {
        console.warn("[OAuthHandover] BroadcastChannel post failed:", err);
        return false;
      }
    };

    const postViaOpener = (msg: object) => {
      try {
        if (window.opener && !window.opener.closed) {
          window.opener.postMessage(msg, window.location.origin);

          return true;
        }

        return false;
      } catch (err) {
        console.warn("[OAuthHandover] window.opener.postMessage threw:", err);
        return false;
      }
    };

    if (kind === "signup") {
      try {
        const payload = JSON.stringify({
          ...detail,
          ts: Date.now(),
        });

        localStorage.setItem(BUILDER_OAUTH_HANDOVER_KEY, payload);
      } catch {
        postViaBroadcast(detail);
        postViaOpener(detail);
      }
    } else {
      const broadcastOk = postViaBroadcast(detail);
      const openerOk = postViaOpener(detail);

      if (!broadcastOk && !openerOk) {
        console.error("[OAuthHandover] BOTH login delivery channels failed — the modal will not receive this login.");
      }
    }

    const t = window.setTimeout(() => {
      try {
        window.close();
      } catch {
        // some browsers refuse to close popups they didn't open programmatically
      }
    }, 50);

    return () => window.clearTimeout(t);
  }, [kind]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        height: "100vh",
        fontFamily: '"Inter", sans-serif',
        color: "#2e3860",
        padding: 24,
        textAlign: "center",
      }}
    >
      <div>Completing sign-in…</div>
    </div>
  );
};

export default OAuthHandover;
